import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { acceptBundleMigration, fetchActivePlan } from "../../redux/slices/activePlanSlice";

export const migrationNudgeOptOutKey = (userId?: string) =>
  `tgpt-migration-nudge-optout-${userId ?? ""}`;

export const useAcceptMigration = (onAccepted?: () => void) => {
  const dispatch = useDispatch<AppDispatch>();
  const userId = useSelector((state: { auth }) => state.auth?.currentUser?.userId);

  return useCallback(async (bundleIds: string[]) => {
    await dispatch(acceptBundleMigration({ bundleIds })).unwrap();
    localStorage.setItem(migrationNudgeOptOutKey(userId), "true");
    onAccepted?.();
    dispatch(fetchActivePlan());
  }, [dispatch, userId, onAccepted]);
};
